/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import Table from "../../components/table/Table";
import api from "../../services/api";
import AuthContext from "../../auth/context";
import AppContext from "../../container/context";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  List,
  ListItem,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { KeyboardArrowRight, ShoppingCart } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

let valorTotal = 0;
let valorFrete = 0;
let valorTotalComFrete = 0;
let escolaId = 0;
let legendaParcelas = "";

const Fechamento = ({ history }) => {
  const [carregando, setCarregando] = useState(true);
  const [carrinho, setCarrinho] = useState([]);
  const [pedidoId, setPedidoId] = useState(0);
  const [opcoesParcelas, setOpcoesParcelas] = useState([]);
  const [fechamentoDisponivel, setFechamentoDisponivel] = useState(true);
  const [qtdParcelas, setQtdParcelas] = useState(0);
  const [processando, setProcessando] = useState(false);
  const [enderecosEntrega, setEnderecoesEntrega] = useState([]);
  const [enderecoEntregaSelecionadoId, setEnderecoEntregaSelecionadoId] =
    useState(0);
  const [opcoesFrete, setOpcoesFrete] = useState([]);
  const [freteSelecionado, setFreteSelecionado] = useState(0);
  const [alterandoEnderecoEntrega, setAlterandoEnderecoEntrega] =
    useState(false);
  const usuario = useContext(AuthContext);
  const [pedidoFechado, setPedidoFechado] = useState(false);
  const { notification } = useContext(AppContext);
  const [alerta, setAlerta] = useState([]);

  useEffect(() => {
    carregar();

    const dataAtual = new Date();
  }, []);

  const carregar = () => {
    api
      .get("carrinhos/carregar")
      .then((dados) => {
        const carrinho = dados.filter((item) => item.quantidade > 0);
        let valorItemCentavos = 0;
        valorTotal = 0;

        carrinho.forEach((item) => {
          valorItemCentavos = item.valorItemCentavos;

          item.promocoes
            .filter((p) => p.valida)
            .forEach((p) => {
              item.promocaoId = p.id;
              valorItemCentavos = p.valorCentavos;
            });

          valorTotal += valorItemCentavos * item.quantidade;
        });

        escolaId = carrinho.length > 0 ? carrinho[0].escolaId : 0;

        setCarrinho(carrinho);

        if (carrinho.length > 0) {
          carregarOpcoesEntrega(escolaId);
        }

        setCarregando(false);
      })
      .catch((e) => "Erro: " + e);
  };

  const carregarOpcoesEntrega = (escolaId) => {
    api
      .get("escolas/enderecosEntrega", { escolaId })
      .then((enderecosEntrega) => {
        if (enderecosEntrega && enderecosEntrega.length > 0) {
          setEnderecoesEntrega(enderecosEntrega);
          carregarFrete();
          return;
        }

        notification(
          "warning",
          "Não foi possível obter as opções de frete. Verifique o endereço cadastrado para a escola."
        );
      })
      .catch((e) => "Erro: " + e);
  };

  const carregarFrete = (CEP) => {
    api
      .get("carrinhos/calculoFrete", {
        usuarioId: usuario.usuario.usuarioId,
        CEP,
      })
      .then((opcoesFrete) => {
        if (opcoesFrete && opcoesFrete.length > 0)
          return setOpcoesFrete(opcoesFrete);

        notification(
          "warning",
          "Não foi possível obter as opções de frete. Verifique o endereço cadastrado para a escola."
        );
      })
      .catch((e) => "Erro: " + e);
  };

  const selecionarFrete = (freteSelecionado) => {
    setFreteSelecionado(freteSelecionado);

    if (freteSelecionado === "VOUCHER") {
      valorFrete = 0;
      valorTotalComFrete = (valorFrete + valorTotal / 100).toFixed(2);

      // return montarParcelas();
      return obterCondicoes();
    }

    const opcaoFreteSelecionada = opcoesFrete.filter(
      (o) => o.servico === freteSelecionado
    )[0];

    if (opcaoFreteSelecionada) {
      valorFrete = opcaoFreteSelecionada
        ? Number(opcaoFreteSelecionada.valor.replace(",", "."))
        : 0;

      valorTotalComFrete = (valorFrete + valorTotal / 100).toFixed(2);

      // montarParcelas();
      obterCondicoes();
    }
  };

  // const montarParcelas = () => {
  //   const opcoes = [];

  //   const dataAtual = new Date();
  //   const diaAtual = dataAtual.getDate();
  //   const mesAtual = dataAtual.getMonth() + 1;
  //   const mesReferencia = mesAtual;//mesAtual === 12 ? 1 : mesAtual;

  //   const parcelaExtra = (diaAtual <= 20 && (mesAtual === 1 || mesAtual === 7)) ? 1 : 0;

  //   opcoes.push({
  //     value: 0,
  //     desc: `(Selecione)`,
  //   });

  //   let max3Parcelas = [252, 311, 312].includes(escolaId)

  //   if (mesReferencia <= 6) {
  //     for (var i = 1; i <= 6 - mesReferencia + parcelaExtra; i++) {
  //       if(!(i > 3 && max3Parcelas)){
  //         opcoes.push({
  //           value: i,
  //           desc: `${i}x de R$ ${(valorTotalComFrete / i).toFixed(2)}`,
  //         });
  //       }
  //     }
  //   } else {
  //     for (var i = 1; i <= 12 - mesReferencia + parcelaExtra; i++) {
  //       if(!(i > 3 && max3Parcelas)){
  //         opcoes.push({
  //           value: i,
  //           desc: `${i}x de R$ ${(valorTotalComFrete / i).toFixed(2)}`,
  //         });
  //       }
  //     }
  //   }
  //   setOpcoesParcelas(opcoes);
  //   obterCondicoes()
  // };

  const obterCondicoes = () => {
    const opcoes = [
      {
        value: 0,
        desc: `(Selecione)`,
      },
    ];
    api
      .get("carrinhos/condicoesFechamento", { escolaId: escolaId })
      .then((parcelas) => {
        for (var i = 1; i <= parcelas.maxParcelas; i++) {
          opcoes.push({
            value: i,
            desc: `${i}x de R$ ${(valorTotalComFrete / i).toFixed(2)}`,
          });
        }

        // const legendaAlerta = [];
        // if (parcelas.codigos.includes(1))
        //   legendaAlerta.push(
        //     "Escola com fatura já fechada para o mês. O próximo pedido terá o primeiro pagamento para o mês seguinte."
        //   );

        // setAlerta(legendaAlerta);
        setOpcoesParcelas(opcoes);
      })
      .catch((e) => "Erro: " + e);
  };

  const fecharPedido = () => {
    if (qtdParcelas < 1)
      return notification("warning", "Selecione a quantidade de parcelas.");

    setProcessando(true);

    const dadosPedido = {
      usuarioId: usuario.usuario.usuarioId,
      pagamentoQtdParcelas: qtdParcelas,
      freteServico: freteSelecionado,
      freteValor: valorFrete,
      freteVoucherFreteGratisId:
        freteSelecionado === "VOUCHER"
          ? opcoesFrete.filter((of) => of.voucherFreteGratisId)[0]
              .voucherFreteGratisId
          : "",

      // enderecoEntregaId: enderecoEntregaSelecionadoId,
      // frete:
      //   freteSelecionado === "VOUCHER"
      //     ? {
      //         voucherFreteGratisId: opcoesFrete.filter(
      //           (of) => of.voucherFreteGratisId
      //         )[0].voucherFreteGratisId,
      //       }
      //     : {
      //         servico: freteSelecionado,
      //         valor: valorFrete,
      //       },
    };

    api
      .put("pedidos/inserir", dadosPedido)
      .then((res) => {
        setProcessando(false);
        setPedidoFechado(true);

        const { id } = res;

        if (id > 0) {
          localStorage.setItem("painel-escolas@itens-carrinho", 0);
          return setPedidoId(res.id);
        }
      })
      .catch((err) => {
        const { data } = err.response;
        
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Informações de pagamento inválidas");
          case 3:
            return notification("error", "Informações de frete inválidas");
          case 4:
            return notification("error", "Quantidade de parcelas inválida");
          case 5:
            return notification("error", "Carrinho vazio");
          case 6:
            return notification("error", "Email financeiro inválido");
          case 7:
            return notification("error", "Dia para pagamento inválido");
          case 8:
            return notification("error", "CNPJ inválido");
          case 9:
            return notification("error", "CEP inválido");
          case 10:
            return notification("error", "Opção de frete inválida");
          case 11:
            return notification("error", "Não há opção de frete disponível");
          case 12:
            return notification("error", "Valor de frete inválido");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const selecionarEndereco = (enderecoSelecionado) => {
    setEnderecoEntregaSelecionadoId(
      enderecoSelecionado ? enderecoSelecionado.enderecoEntregaId : 0
    );
    setAlterandoEnderecoEntrega(false);
    setFreteSelecionado(0);
    carregarFrete(
      enderecoSelecionado ? enderecoSelecionado.enderecoEntregaCEP : undefined
    );
  };

  const registrosTabela = montarTabelaCarrinho(carrinho);

  const enderecoEntregaSelecionado = enderecoEntregaSelecionadoId
    ? enderecosEntrega.filter(
        (ee) => ee.enderecoEntregaId === enderecoEntregaSelecionadoId
      )[0]
    : undefined;
  return (
    <>
      {alterandoEnderecoEntrega && (
        <DialogoSelecaoEnderecoEntrega
          enderecos={enderecosEntrega}
          enderecoSelecionadoId={enderecoEntregaSelecionadoId}
          selecionarEndereco={selecionarEndereco}
          recarregar={carregar}
        />
      )}

      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <h2>Fechamento de pedido</h2>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ShoppingCart />}
          onClick={() => history.push("/app/carrinho")}
        >
          Meu carrinho
        </Button>
      </Grid>
      {pedidoId > 0 && (
        <div className="main-container">
          <h4>Pedido gerado com sucesso!</h4>
          <br />
          <h4>
            Código: <b>{pedidoId.toString().padStart(5, "0")}</b>
          </h4>
        </div>
      )}
      {carregando ? (
        <CircularProgress />
      ) : carrinho.length > 0 && enderecosEntrega.length > 0 ? (
        <>
          {!fechamentoDisponivel && (
            <div className="main-container">
              <h3 style={{ color: "red" }}>
                Data atual fora do período estipulado para novos pedidos.
              </h3>
            </div>
          )}

          <div className="main-container">
            <Grid container>
              <Grid item md={3}>
                <h3>Entregar para</h3>
                <p>{carrinho[0].escolaNome}</p>
                {enderecoEntregaSelecionado ? (
                  <>
                    <p>{`${enderecoEntregaSelecionado.enderecoEntregaLogradouro} ${enderecoEntregaSelecionado.enderecoEntregaNumero}`}</p>
                    <p>{`${enderecoEntregaSelecionado.enderecoEntregaCEP} ${enderecoEntregaSelecionado.enderecoEntregaCidade} ${enderecoEntregaSelecionado.enderecoEntregaUF}`}</p>
                    <Button
                      color="primary"
                      round
                      onClick={() => setAlterandoEnderecoEntrega(true)}
                    >
                      Alterar endereço de entrega
                    </Button>
                  </>
                ) : (
                  <>
                    <p>{`${enderecosEntrega[0].escolaEndereco} ${enderecosEntrega[0].escolaNumero}`}</p>
                    <p>{`${enderecosEntrega[0].escolaCep} ${enderecosEntrega[0].escolaMunicipio} ${enderecosEntrega[0].escolaUF}`}</p>
                    <Button
                      disabled={pedidoFechado}
                      color="primary"
                      round
                      onClick={() => setAlterandoEnderecoEntrega(true)}
                    >
                      Alterar endereço de entrega
                    </Button>
                  </>
                )}
              </Grid>
              <Grid item md={3}>
                <h3>Frete</h3>
                {fechamentoDisponivel ? (
                  <Select
                    disabled={pedidoFechado}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={freteSelecionado}
                    onChange={(e) => selecionarFrete(e.target.value)}
                  >
                    <MenuItem key={0} value={0}>
                      (Selecione)
                    </MenuItem>
                    {opcoesFrete.map((opc, key) =>
                      opc.voucherFreteGratisId ? (
                        <MenuItem key={key} value={"VOUCHER"}>
                          Grátis (utilizar voucher)
                        </MenuItem>
                      ) : (
                        <MenuItem key={key} value={opc.servico}>
                          {opc.servico} R$ {opc.valor}{" "}
                          {opc.prazo && `- ${opc.prazo} dia(s)`}{" "}
                        </MenuItem>
                      )
                    )}
                  </Select>
                ) : (
                  <p>(indisponível)</p>
                )}
              </Grid>

              <Grid item md={3}>
                <h3>Valor Total</h3>
                {fechamentoDisponivel ? (
                  freteSelecionado ? (
                    <>
                      <p>Produtos + Frete</p>
                      <h3>R$ {valorTotalComFrete}</h3>
                    </>
                  ) : (
                    <p>(Selecione o frete)</p>
                  )
                ) : (
                  <p>(indisponível)</p>
                )}
              </Grid>
              <Grid item md={3}>
                <h3>Pagamento</h3>
                {fechamentoDisponivel ? (
                  <Grid container>
                    <Grid item md={4}>
                      {pedidoId === 0 && freteSelecionado ? (
                        <>
                          <h5>Parcelas</h5>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={qtdParcelas}
                            onChange={(e) => setQtdParcelas(e.target.value)}
                          >
                            {opcoesParcelas.map((opc, key) => (
                              <MenuItem key={key} value={opc.value}>
                                {opc.desc}
                              </MenuItem>
                            ))}
                          </Select>
                        </>
                      ) : (
                        <h5>(Selecione o frete)</h5>
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  <p>(indisponível)</p>
                )}
              </Grid>
              {pedidoId === 0 && (
                <Grid
                  style={{ marginTop: 15 }}
                  container
                  spacing={2}
                  justifyContent="flex-end"
                >
                  <Grid justifyContent="flex-end" container item md={3}>
                    {processando ? (
                      <CircularProgress />
                    ) : freteSelecionado &&
                      opcoesParcelas.length > 0 &&
                      fechamentoDisponivel ? (
                      <Button
                        color="primary"
                        variant="contained"
                        round
                        onClick={fecharPedido}
                      >
                        Fechar pedido <KeyboardArrowRight />
                      </Button>
                    ) : null}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </div>
          <br />

          {alerta.length > 0 && (
            <>
              {alerta.map((item) => (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    marginBottom: 10,
                  }}
                >
                  <p
                    style={{
                      color: "#663c00",
                      background: "#fff4e5",
                      padding: 10,
                      borderRadius: "5px",
                    }}
                  >
                    {item}
                  </p>
                </div>
              ))}
            </>
          )}

          <div className="main-container">
            <h3>Produtos</h3>
            <Grid container>
              <Grid item md={12}>
                <Table
                  tableHead={[
                    "PRODUTO",
                    "QUANTIDADE",
                    "VALOR UNITÁRIO",
                    "VALOR TOTAL",
                  ]}
                  tableData={registrosTabela}
                />
              </Grid>
            </Grid>
          </div>
        </>
      ) : (
        <h3>Ainda não há itens no seu carrinho.</h3>
      )}
    </>
  );
};

export default Fechamento;

const DialogoSelecaoEnderecoEntrega = ({
  enderecos,
  enderecoSelecionadoId,
  selecionarEndereco,
  recarregar,
}) => {
  const classes = useStyles();

  const [novoEndereco, setNovoEndereco] = useState(false);
  const [enderecoSelecionado, setEnderecoSelecionado] = useState({});

  const preencher = (campo, valor) => {
    const enderecoAtualizado = { ...enderecoSelecionado };

    enderecoAtualizado[campo] = valor;

    setEnderecoSelecionado(enderecoAtualizado);
  };

  const salvar = () => {
    if (enderecoSelecionado.enderecoEntregaId) {
      //TODO: Editar endereço
    } else {
      enderecoSelecionado.enderecoEntregaEscolaId = escolaId;

      api
        .post("escolas/inserirEnderecoEntrega", enderecoSelecionado)
        .then(() => {
          notification(
            "success",
            "Endereço de entrega cadastrado com sucesso!"
          );
          recarregar();
          setNovoEndereco(false);
        })
        .catch(() =>
          notification(
            "error",
            "Não foi possível salvar o endereço. Verifique os dados e tente novamente."
          )
        );
    }
  };

  return (
    <Dialog
      onClose={() => {}}
      aria-labelledby="simple-dialog-title"
      open={true}
    >
      <DialogTitle id="simple-dialog-title">
        {novoEndereco ? "Novo endereço" : "Selecione o endereço de entrega"}
      </DialogTitle>
      {novoEndereco ? (
        <form className={classes.rootForm} noValidate autoComplete="off">
          <TextField
            id="standard-full-width"
            label="CEP"
            placeholder="CEP"
            fullWidth
            margin="normal"
            value={enderecoSelecionado.enderecoEntregaCEP}
            onChange={(e) => preencher("enderecoEntregaCEP", e.target.value)}
          />
          <TextField
            id="standard-full-width"
            label="Logradouro"
            placeholder="Logradouro"
            fullWidth
            margin="normal"
            value={enderecoSelecionado.enderecoEntregaLogradouro}
            onChange={(e) =>
              preencher("enderecoEntregaLogradouro", e.target.value)
            }
          />
          <TextField
            id="standard-full-width"
            label="Número"
            placeholder="Número"
            fullWidth
            margin="normal"
            value={enderecoSelecionado.enderecoEntregaNumero}
            onChange={(e) => preencher("enderecoEntregaNumero", e.target.value)}
          />
          <TextField
            id="standard-full-width"
            label="Bairro"
            placeholder="Bairro"
            fullWidth
            margin="normal"
            value={enderecoSelecionado.enderecoEntregaBairro}
            onChange={(e) => preencher("enderecoEntregaBairro", e.target.value)}
          />
          <TextField
            id="standard-full-width"
            label="Cidade"
            placeholder="Cidade"
            fullWidth
            margin="normal"
            value={enderecoSelecionado.enderecoEntregaCidade}
            onChange={(e) => preencher("enderecoEntregaCidade", e.target.value)}
          />
          <TextField
            labelId="demo-simple-select-label"
            id="standard-full-width"
            label="UF"
            placeholder="UF"
            value={
              enderecoSelecionado.enderecoEntregaUF
                ? enderecoSelecionado.enderecoEntregaUF
                : ""
            }
            onChange={(e) => preencher("enderecoEntregaUF", e.target.value)}
            select
            fullWidth
          >
            <MenuItem key={""} value={""}>
              (Selecione)
            </MenuItem>
            {ufs.map((uf) => (
              <MenuItem key={uf} value={uf}>
                {uf}
              </MenuItem>
            ))}
          </TextField>
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            onClick={salvar}
          >
            Salvar
          </Button>
          <Button
            variant="contained"
            className={classes.btn}
            onClick={() => setNovoEndereco(false)}
          >
            Cancelar
          </Button>
        </form>
      ) : (
        <>
          {enderecos.length > 0 ? (
            <List style={{ overflow: "auto" }}>
              <ListItem autoFocus button onClick={() => selecionarEndereco()}>
                <Card
                  key={0}
                  className={
                    enderecoSelecionadoId === 0
                      ? classes.selectedCard
                      : classes.selected
                  }
                >
                  <CardContent>
                    <p>{`${enderecos[0].escolaEndereco} ${enderecos[0].escolaNumero}`}</p>
                    <p>{`${enderecos[0].escolaCep} ${enderecos[0].escolaMunicipio} ${enderecos[0].escolaUF}`}</p>
                  </CardContent>
                </Card>
              </ListItem>
              {enderecos
                .filter((e) => e.enderecoEntregaId)
                .map((endereco) => (
                  <ListItem
                    autoFocus
                    button
                    onClick={() => selecionarEndereco(endereco)}
                  >
                    <Card
                      key={endereco.enderecoEntregaId}
                      className={
                        enderecoSelecionadoId === endereco.enderecoEntregaId
                          ? classes.selectedCard
                          : classes.selected
                      }
                    >
                      <CardContent>
                        <p>{`${endereco.enderecoEntregaLogradouro} ${endereco.enderecoEntregaNumero}`}</p>
                        <p>{`${endereco.escolaCep} ${enderecos[0].enderecoEntregaCidade} ${enderecos[0].enderecoEntregaUF}`}</p>
                      </CardContent>
                    </Card>
                  </ListItem>
                ))}
            </List>
          ) : (
            <h4>Escola sem endereço cadastrado.</h4>
          )}
          <Card className={classes.root}>
            <CardContent>
              <CardActions onClick={() => setNovoEndereco(true)}>
                <Button size="small">Novo endereço</Button>
              </CardActions>
            </CardContent>
          </Card>
        </>
      )}
    </Dialog>
  );
};

const montarTabelaCarrinho = (carrinho) => {
  const registros = [];

  let valorUnitarioItem = 0;
  let valorTotalItem = 0;
  let valorTotalGeral = 0;

  carrinho.forEach((item) => {
    valorUnitarioItem = item.valorItemCentavos;
    valorTotalItem = valorUnitarioItem * item.quantidade;

    let promocaoItem;

    item.promocoes
      .filter((p) => p.valida)
      .forEach((p) => {
        valorUnitarioItem = p.valorCentavos;
        valorTotalItem = valorUnitarioItem * item.quantidade;

        return (promocaoItem = p);
      });

    valorTotalGeral += valorUnitarioItem * item.quantidade;

    registros.push([
      promocaoItem ? (
        <div>
          <p>{item.produtoNome}</p>
          <div style={{ background: "#afcca9", padding: 5 }}>
            <h4>Promoção/Condição especial de venda</h4>
            <small>{promocaoItem.descricao}</small>
          </div>
        </div>
      ) : (
        <p>{item.produtoNome}</p>
      ),
      item.quantidade,
      `R$ ${(valorUnitarioItem / 100).toFixed(2)}`,
      `R$ ${(valorTotalItem / 100).toFixed(2)}`,
    ]);
  });

  registros.push([
    "",
    "",
    <b>Total:</b>,
    `R$ ${(valorTotalGeral / 100).toFixed(2)}`,
  ]);

  return registros;
};

const useStyles = makeStyles({
  card: {
    minWidth: 275,
  },
  selectedCard: {
    minWidth: 275,
    backgroundColor: "#b5d5ff",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 8,
  },
  rootForm: {
    display: "flex",
    flexWrap: "wrap",
    padding: 15,
  },
  btn: {
    marginRight: 8,
    marginTop: 8,
  },
});

const ufs = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];
